import React, { useEffect, useState } from 'react';
import '../SettingCategory.css';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import Checkbox from '@material-ui/core/Checkbox';
import UnCheckIcon from './UnCheckIcon';
import CheckedIcon from './CheckedIcon';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { useRecoilState } from 'recoil';
import { updatePreviewCategoryListAtom } from '@/state/atom/chatBotPreview';
import { cloneDeep, orderBy } from 'lodash';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ListTagField({
    usedTags,
    unusedTags,
    setUsedTags,
    setUnUsedTags,
    projectName,
    editCategoryId,
    setIsEdited,
    setIsDataChanged,
    setIsDisableBtnSubmit
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [isToggleListActive, setIsToggleListActive] = useState(false);
    const [isToggleListInActive, setIsToggleListInActive] = useState(false);
    const [previewCategoryList,setPreviewCategoryList] = useRecoilState(updatePreviewCategoryListAtom)


    const reorder = (list, startIndex, endIndex) => {
        let result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        result = result.map((item, index) => {
            item.order = index + 1;
            return item;
        });
        setIsEdited(true);
        setIsDisableBtnSubmit(false)
        setIsDataChanged(true);

        return result;
    };

    const onDragEndUsedTags = result => {
        if (!result.destination) {
            return;
        }
        const items = reorder(usedTags, result.source.index, result.destination.index);
        setUsedTags(items);
    };

    const onDragEndUnUsedTags = result => {
        if (!result.destination) {
            return;
        }
        const items = reorder(unusedTags, result.source.index, result.destination.index);
        setUnUsedTags(items);
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        // change background colour if dragging
        background: isDragging ? '#C7CAD1' : '#FFFFFF',

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const onChangePinTag = (item, unpin) => {
        let leftTagItems = []
        if (unpin) {
            leftTagItems = usedTags.filter(tag => tag.id !== item.id);
            setUsedTags(leftTagItems);
            unusedTags.push(item);
            unusedTags = orderBy(unusedTags, [tag => tag?.name && tag.name.toLowerCase()], ['asc']);
            setUnUsedTags(unusedTags);
        } else {
            item.priority = false;
            leftTagItems = unusedTags.filter(tag => tag.id !== item.id);
            setUnUsedTags(leftTagItems);
            usedTags.push(item);
            setUsedTags(usedTags);
        }

        let listTagFiledId = leftTagItems?.map(tagField =>{return tagField.id});
        updatePreviewChatBotOnChangePinTagField(listTagFiledId);
        setIsEdited(true);
        setIsDisableBtnSubmit(false)
        setIsDataChanged(true);
    };

    const onChangeCheckbox = (item) => {
        let itemData = cloneDeep(item);
        itemData.priority = item.priority ? false : true;
        const newUsedTags = usedTags.map(tag => {
            if (tag.id === itemData.id) tag.priority = itemData.priority;
            return tag;
        });

        updatePreviewChatBotOnChangePriority(itemData, itemData.priority)
        setUsedTags(newUsedTags);
        setIsEdited(true);
        setIsDisableBtnSubmit(false)
        setIsDataChanged(true);
    };

    const updatePreviewChatBotOnChangePinTagField = (newListTagFieldId) => {
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === editCategoryId
        })

        if(indexOfEditCategory >= 0){

            let cloneEditCategory = previewCategoryListClone[indexOfEditCategory];
            let listTagFields = cloneEditCategory[`chatBotCategorySetting`].tagFields
           
            listTagFields = listTagFields.filter((tagField) => {
               return newListTagFieldId.includes(tagField.id)
            })
           
            cloneEditCategory.listTagFiledId = newListTagFieldId
            cloneEditCategory[`chatBotCategorySetting`].tagFields = listTagFields
            
            previewCategoryListClone[indexOfEditCategory] = cloneEditCategory
            setPreviewCategoryList([...previewCategoryListClone])
        }
    }

    const updatePreviewChatBotOnChangePriority = (item,newPriority) => {
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === editCategoryId
        })

        if(indexOfEditCategory >= 0){

            let cloneEditCategory = previewCategoryListClone[indexOfEditCategory];
            let listTagFields = cloneEditCategory[`chatBotCategorySetting`].tagFields

            let indexOfField = listTagFields.findIndex(tagField => {
                return tagField.id === item.id
            });

            if(indexOfField >=0){

            let fieldDetail = listTagFields[indexOfField];
            fieldDetail.priority = newPriority;
            listTagFields[indexOfField] = fieldDetail;

            cloneEditCategory[`chatBotCategorySetting`].tagFields = listTagFields;
            previewCategoryListClone[indexOfEditCategory] = cloneEditCategory;
            setPreviewCategoryList([...previewCategoryListClone]);
            }
           
        }
    }

    useEffect(() => {
        if (usedTags.length > 0) setIsToggleListActive(true);
    }, [usedTags])

    return (
        <div className="list-tagfield-category">
            {/* list tag field active  */}
            <div className="tagfield-active">
                <div
                    className="accordion-head"
                    onClick={() => setIsToggleListActive(prev => !prev)}
                >
                    <img src="/assets/image/icon-pin.svg" alt="" />
                    <span classname="accordionHead-text">
                        {tr('以下のフィールドは使用する')} ({usedTags.length})
                    </span>
                    {isToggleListActive ? (
                        <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus" />
                    ) : (
                        <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                    )}
                </div>

                <DragDropContext onDragEnd={onDragEndUsedTags}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={`${
                                    isToggleListActive ? 'list-active' : 'list-active-none'
                                }`}
                            >
                                {usedTags.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                className="item-tagfield-category"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                <img
                                                    src="/assets/image/icon-field.svg"
                                                    alt=""
                                                    className="icon-tagfield"
                                                />
                                                <div className="name-tagfield">
                                                    <span>{trLabel(item.name)}</span>
                                                    <span>
                                                        {Utils.getTextByLanguage(
                                                            Constant.LANGUAGE_TYPE.JP,
                                                            projectName
                                                        )}
                                                    </span>
                                                </div>
                                                <div>
                                                    <img
                                                        src="/assets/image/icon-pin.svg"
                                                        alt=""
                                                        className="icon-pin-item"
                                                        onClick={() => onChangePinTag(item, true)}
                                                    />
                                                    <Checkbox
                                                        defaultChecked={item.priority ? true : false}
                                                        checked={item.priority ? true : false}
                                                        icon={<UnCheckIcon />}
                                                        checkedIcon={<CheckedIcon />}
                                                        onClick={() => onChangeCheckbox(item)}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>

            {/* list tag field inactive  */}
            <div className="tagfield-active">
                <div
                    className="accordion-head"
                    onClick={() => setIsToggleListInActive(prev => !prev)}
                >
                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                    <span className="accordionHead-text">
                        {tr('以下のフィールドは使用しない')} ({unusedTags.length})
                    </span>
                    {isToggleListInActive ? (
                        <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus" />
                    ) : (
                        <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                    )}
                </div>

                <DragDropContext onDragEnd={onDragEndUnUsedTags}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={`${
                                    isToggleListInActive ? 'list-active' : 'list-active-none'
                                }`}
                            >
                                {unusedTags.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                className="item-tagfield-category"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                <img
                                                    src="/assets/image/icon-field.svg"
                                                    alt=""
                                                    className="icon-tagfield"
                                                />
                                                <div className="name-tagfield">
                                                    <span>{trLabel(item.name)}</span>
                                                    <span>
                                                        {Utils.getTextByLanguage(
                                                            Constant.LANGUAGE_TYPE.JP,
                                                            projectName
                                                        )}
                                                    </span>
                                                </div>
                                                <div>
                                                    <img
                                                        src="/assets/image/icon-pin-outline.svg"
                                                        alt=""
                                                        className="icon-upin-item"
                                                        onClick={() => onChangePinTag(item, false)}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </div>
    );
}
